import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import TitleAndClientSection from "./TitleAndClientSection";
import ProjectSection from "./ProjectSection";
import UploadProjectFile from "./UploadProjectFile";
import ButtonSection from "./ButtonSection";

import { profileValidation } from "../../../../Data/Application/ProjectList/ProjectList";

import { UserProfileInitialValue } from "../../../../Types/Application/ProjectList/ProjectList";

import apiRequestHelper from "../../../../utils/apiRequestHelper";
const CreateNewProjectForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPathname = location.pathname;

  const [initialValues, setInitialValues] = useState<UserProfileInitialValue>({
    name: "",
    email: "",
    password: "",
    username: "",
  });

  // Fetch user/author data for edit
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const endpoint = `/profile`;
      const res = await apiRequestHelper.get("/profile");
      const data = res.data.data["user"];
      setInitialValues((prev) => ({
        ...prev,
        ...data,
      }));
    } catch (err) {
      toast.error("Failed to load data for editing.");
    }
  };
  const projectSubmit = async (values: UserProfileInitialValue) => {
    try {
      const payload = values; // for user, regular JSON
      console.log("Submitting profile data:", payload);
      const response = await apiRequestHelper.put(`/profile`, payload); // third param tells backend it's multipart

      toast.success(`Profile Updated successfully!`);

      navigate("/dashboard");
    } catch (error: any) {
      console.error("Error submitting:", error);
      toast.error(
        error.response?.data?.messages?.[0]?.message ||
          `${currentPathname.includes("/edit") ? "Update" : "Create"} failed.`
      );
    }
  };

  return (
    <Formik<UserProfileInitialValue>
      initialValues={initialValues}
      enableReinitialize
      validationSchema={profileValidation}
      onSubmit={projectSubmit}
    >
      {() => (
        <Form className="theme-form">
          <TitleAndClientSection />
          <ProjectSection />
          <ButtonSection />
        </Form>
      )}
    </Formik>
  );
};

export default CreateNewProjectForm;
